<template>
  <div class="general-frame">
    <div class="general-neick">
      <el-date-picker
        v-model="value1"
        type="week"
        format="yyyy 第 WW 周"
        value-format="yyyy-MM-dd"
        placeholder="选择周"
        @change="dsadas()"
      >
      </el-date-picker>
    </div>
  </div>
</template>

<script>
import noData from "@/components/html/noData";
export default {
  components: {
    noData
  },
  data() {
    return {
      value1: "",
      data: [
        { name: "首页", route: "home" },
        { name: "真空排水", route: "/vacuumStationInfo" },
        { name: "真空厕所列表", route: "/toiletInfo" },
        { name: "真空厕所详情", route: "/toiletDetail" },
        { name: "真空厕所报表", route: "/toiletAnalysis" },
        { name: "真空&智慧厕所报表", route: "/toileUseThePaper" },
        { name: "真空厕所地图", route: "/toiletMap" },
        { name: "工单管理", route: "/workOrder" },
        { name: "运维公司管理", route: "/company" },
        { name: "后台人员管理", route: "/userDetails" },
        { name: "用户管理-权限组管理", route: "/user" }
      ]
    };
  },
  methods: {
    dsadas() {}
  },
  mounted() {
    var item = [];
    var obj = JSON.parse(localStorage.getItem("jurisdiction"));
    var arr = Object.getOwnPropertyNames(obj); //arr=["one", "two"]
    var valArr = arr.map(function(i) {
      return obj[i];
    });
    for (var i = 0; i < this.global.data.length; i++) {
      if (valArr.indexOf(this.global.data[i].name) != -1) {
        item.push(this.global.data[i].route);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/one.vue